(function () {
	'use strict';

	angular.module('mx.components').directive('mxCurrentElement', function mxCurrentElementDirective() {
		return function (scope, element) {
			if (typeof scope.initCurrentElement === 'function') {
				scope.initCurrentElement(element);
			}
		};
	});
})();
